var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg132(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504 506",
    width: 504,
    height: 506,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1-32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #ffb600 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m186.7 420.9l0.3-80.9c36.5 27 85.5 30.8 125.2 8.3l13.1-8.3v80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m82 399.8c2.1-14.5 6.6-27.6 15.1-39.6 15.8-22.3 41.9-34.6 69.2-34.5v95.2h-84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m430 420.9h-84.3v-95.2c17.3 0.2 33.8 4.4 48.2 14 21 14.1 34.1 37.2 36.1 62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m349.1 234.7c1.7 25-2.3 47.8-16.8 68.4-37.2 52.6-115.4 52.6-152.6 0-14.6-20.7-18.5-43.3-16.8-68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m139.8 188.4h232.4v25.9h-232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m235.6 72.9h40.8v95.2h-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m215.2 168.1h-51.6c2.3-31.5 23.5-60 51.6-73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m348.4 168.1h-51.6v-73.4c28.1 13.4 49.2 41.9 51.6 73.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg132);
export default __webpack_public_path__ + "static/media/1-32.c7c268f7fda0083c05fd4c4a2792f75b.svg";
export { ForwardRef as ReactComponent };